module.exports = __webpack_public_path__ + "img/Company_DT.37be2bbe.png";